import {Component, Input} from '@angular/core';
import {
  ClassResponse,
  EventResponse,
  HorseRegistryResponse,
  MembershipPlanResponse,
  SponsorResponse
} from '../../../../../../../../../../@shared/models/response.module';
import {ClassesService} from '../../../../../../../../../../@shared/services/classes-service';
import {EventsService} from '../../../../../../../../../../@shared/services/events-service';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {_AQH_EVE_17, _AQH_EVE_7, AQH_CLS_0} from '../../../../../../../../../../@shared/models/input.module';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {StaticService} from '../../../../../../../../../../@shared/services/static-service';
import {firstValueFrom} from 'rxjs';
import { AddSponsor } from '../../../manage-event-sponsor/components/add-sponsor/add-sponsor';

@Component({
  selector: 'app-add-class',
  standalone: false,
  templateUrl: './add-class.html',
  styleUrl: './add-class.css'
})
export class AddClass {
  @Input() event: EventResponse
  classTypes: ClassResponse[]
  horseRegistries: HorseRegistryResponse[]
  membershipPlans: MembershipPlanResponse[]

  selectedSponsors: SponsorResponse[] = [];

  form: FormGroup;
  saving = false;


  constructor(private classService: ClassesService,
              private eventService: EventsService,
              private staticService: StaticService,
              private fb: FormBuilder,
              private modal: NgbActiveModal,
              private modalService: NgbModal) {
    this.form = this.fb.group({
      class_name: ['', [Validators.required, Validators.maxLength(200)]],
      class_description: [''],
      parent_class_id: [null],
      max_num_registrations: [null],
      start_date_time: ['', Validators.required],
      req_membership_plans: [[] as number[]],
      req_horse_registration_id: [null],
      max_participant_age: [null],
      min_horse_age: [null],
      time_per_participant_seconds: [null],
      price: [null],
      price_currency: ['NOK'],
    });
  }



  ngOnInit() {
    this.getClassTypes()
    this.getHorseRegistries()
    this.getMembershipPlans()
  }

  getClassTypes() {
    let payload: AQH_CLS_0 = {}
    this.classService.getClasses(payload).subscribe((data) => {
      this.classTypes = data.data
    });
  }

  getHorseRegistries() {
    return this.staticService.getHorseRegistries().subscribe((res) => {
      this.horseRegistries = res.data;
    });
  }

  getMembershipPlans() {
    this.staticService.getMembershipPlans().subscribe((res) => {
      console.log("Membership Plans:", res);
      this.membershipPlans = res;
    })
  }

  v(name: string) {
    return this.form.get(name)?.value;
  }
  set(name: string, value: any) {
    this.form.get(name)?.setValue(value);
    this.form.get(name)?.markAsDirty();
  }

  setMembershipIds(ids: number[]) {
    this.set('req_membership_plan_ids', ids);
  }

  removeSponsor(sponsor: SponsorResponse) {
    this.selectedSponsors = this.selectedSponsors.filter(s => s.sponsor_id !== sponsor.sponsor_id);
  }

  async save() {
    if (this.form.invalid || !this.event?.event_id) {
      this.form.markAllAsTouched();
      return;
    }
    this.saving = true;

    try {
      const payload: _AQH_EVE_7 = {
        event_id: this.event.event_id,
        parent_class_id: this.v('parent_class_id')?.class_id ?? undefined,
        class_name: this.v('class_name'),
        class_description: this.v('class_description'),
        max_num_registrations: this.v('max_num_registrations') ?? undefined,
        start_date_time: this.v('start_date_time'),
        req_membership_plan_ids: (this.v('req_membership_plans') || []).map((p: any) => p.plan_id),
        req_horse_registration_id: this.v('req_horse_registration_id') ?? undefined,
        max_participant_age: this.v('max_participant_age') ?? undefined,
        min_horse_age: this.v('min_horse_age') ?? undefined,
        time_per_participant_seconds: this.v('time_per_participant_seconds') ?? undefined,
        price: this.v('price') ?? undefined,
        price_currency: this.v('price_currency') ?? undefined,
      };
      console.log("payload:", payload);

      // Create the event class first
      const res = await firstValueFrom(this.eventService.addEventClass(payload));
      console.log("Class added:", res);

      // If sponsors were selected, add them to the newly created class
      if (this.selectedSponsors.length > 0 && res.data?.event_class_id) {
        const event_class_id = res.data.event_class_id;

        // Add all selected sponsors
        for (const sponsor of this.selectedSponsors) {
          const sponsorPayload: _AQH_EVE_17 = {
            event_class_id: event_class_id,
            sponsor_id: sponsor.sponsor_id
          };
          await firstValueFrom(this.eventService.addSponsorToEventClass(sponsorPayload));
        }
      }

      this.saving = false;
      this.modal.close(true);
    } catch (error) {
      console.error('Error saving class:', error);
      this.saving = false;
    }
  }

  openCreateSponsorModal() {
    const modalRef = this.modalService.open(AddSponsor, { size: 'lg', centered: true });
    modalRef.componentInstance.event = this.event;

    modalRef.result.then((result: SponsorResponse) => {
      if (result && result.sponsor_id) {
        // Create the sponsor object
        const newSponsor: SponsorResponse = {
          sponsor_id: result.sponsor_id,
          sponsor_name: result.sponsor_name || 'New Sponsor',
          sponsor_description: result.sponsor_description || '',
          logo_url: result.logo_url,
          image_url: result.image_url
        };

        // Add to selected sponsors list by creating a new array (triggers change detection)
        if (!this.selectedSponsors.find(s => s.sponsor_id === newSponsor.sponsor_id)) {
          this.selectedSponsors = [...this.selectedSponsors, newSponsor];
        }
      }
    }, () => {});
  }

  close() {
    this.modal.close()
  }

  setHorseRegistries(event: any) {

  }

}
